export default "__VITE_ASSET__Dvm1U33D__"